<div class="installation-info">
	<div class="header">
		<h2>{{ 'confirm_installation' | translate }}</h2>
	</div>

	<div class="sensor-info">
		<div class="sensor-name">
			<h4>{{ modalData.sensor.name }}</h4>
			<p class="sensor-serial">
				<span>{{ 'serial_number_short' | translate }}</span
				>&nbsp;{{ modalData.sensor.serialNumber }}
			</p>
		</div>
		<div class="manufacturer">
			<p class="label">{{ 'manufacturer' | translate }}</p>
			<p class="high">{{ modalData.sensor.sensorManufacturer }}</p>
		</div>
		<div class="sensor-type">
			<p class="label">{{ 'type' | translate }}</p>
			<p class="high">
				{{ modalData.sensor.sensorType }}
			</p>
		</div>
		<div class="sensor-function">
			<p class="label">{{ 'sensor_function' | translate }}</p>
			<p class="high">
				@if (modalData.sensor.tags.length) {
					<span>
						@for (tag of modalData.sensor.tags; track tag; let last = $last) {
							<span> {{ tag.name }}{{ last ? '' : ', ' }} </span>
						}
					</span>
				} @else {
					<span class="no-data">{{ 'not_assigned' | translate }}</span>
				}
			</p>
		</div>
		<!--  Not available in current structure  -->
		<!--	<div class="capabilities">-->
		<!--		<p class="label">Capabilities</p>-->
		<!--		<p class="high">-->
		<!--			<span-->
		<!--				*ngFor="-->
		<!--					let capabilityItem of modalData.sensor.sensorType.capability;-->
		<!--					let last = last-->
		<!--				"-->
		<!--			>-->
		<!--				{{ capabilityItem.capability }}&nbsp;({{ capabilityItem.unit }}){{-->
		<!--					last ? '' : ', '-->
		<!--				}}-->
		<!--			</span>-->
		<!--		</p>-->
		<!--	</div>-->
		<div class="rssi">
			<p class="label">{{ 'signal_strength' | translate }}</p>
			@if (signalStrength) {
				<p
					class="high signal"
					[ngClass]="signalStrength > sensorThreshold ? 'high-signal' : 'low-signal'"
				>
					{{ signalStrength }}%
				</p>
			} @else {
				<p class="high no-data">{{ 'no_signal' | translate }}</p>
			}
		</div>

		<div class="last-data">
			<p class="label">{{ 'last_data' | translate }}</p>
			<p class="high">
				{{ minutesLastDataReceivedAgo ? minutesLastDataReceivedAgo + 'm ago' : '-' }}
			</p>
		</div>
		<div class="description">
			<p class="label">{{ 'description' | translate }}</p>
			<p class="high">{{ modalData.sensor.description || '-' }}</p>
		</div>
		<div class="location">
			<p class="label">{{ 'location' | translate }}</p>
			<h4>
				{{ modalData.sensor.location?.floorName }}&nbsp;|&nbsp;{{
					modalData.sensor.location?.roomName
				}}
			</h4>
		</div>
		<div class="attachment">
			<mat-icon svgIcon="camera"></mat-icon>
			<span class="no-data">{{ 'photo_upload_disabled' | translate }}</span>
		</div>
	</div>
</div>

<mat-dialog-actions>
	<au-techno-btn mat-dialog-close>{{ 'cancel' | translate }}</au-techno-btn>
	<button
		matRipple
		class="au-btn m-l-sm uppercase save-button"
		(click)="confirmApproved()"
	>
		{{ 'confirm' | translate }}
	</button>
</mat-dialog-actions>
